$('body').on('click', '.dropdown-menu a[data-toggle="tab"]', function (e) {
    e.stopPropagation();
    $(this).tab('show');
});

$(document).on('click', '#navbar-top #navbar-layer .dropdown-menu', function (e) {
    e.stopPropagation();
});

$(document).on('click', '#navbar-main-menu .dropdown-menu a[data-toggle="collapse"]', function (e) {
    $($(this).attr('href')).collapse('toggle');
    e.stopPropagation();
});

//all alert 
$('.modal-alert').show().delay(3000).fadeOut();
$('.closeOverlay').on("click", function(e) {
    e.stopPropagation();
    $('.modal-alert').fadeOut("fast");
});

/* dynamic url save to global variable */
window.queryUrl = getParameterByName('q');

/* global variable for dynamic url object */
window.dynamicUrlObj = {
    layers: [],
    mapProperties: {}
}
window.queryUrlLoaded = 0;

// function to get query string data
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    // console.log(results);
    if (!results) return null;
    if (!results[2]) return '';
    // return JSON.parse(decodeURIComponent(results[2].replace(/\+/g, ' ')));
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}